import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTE } from 'src/constants/routes';

import { Button } from 'src/components';

import MonarkLogo from 'src/assets/header/monarkLogo.svg';

import classes from './notAuthorized.module.scss';
import { ERROR } from 'src/constants/errorNames';

export const NotAuthorized = () => {
  const navigate = useNavigate();

  const onRedirectUser = useCallback(() => {
    navigate(ROUTE.DEFAULT);
  }, [navigate]);

  return (
    <div className={classes.Layout}>
      <div className={classes.LayoutEllipseLeft} />
      <div className={classes.LayoutEllipseRight} />
      <div className={classes.LayoutLightLine} />
      <div className={classes.NotAuthorized}>
        <div className={classes.NotAuthorizedCard}>
          <div className={classes.NotAuthorizedLogo}>
            <img src={MonarkLogo} alt="NotAuthorizedMonarkLogo" onClick={onRedirectUser} />
          </div>
          <div className={classes.NotAuthorizedContent}>
            <div className={classes.NotAuthorizedContentTitle}>Access Denied</div>
            <div className={classes.NotAuthorizedContentSubTitle}>{ERROR.INACCESSABLE}</div>

            <div className={classes.NotAuthorizedButton}>
              <Button
                onClick={onRedirectUser}
                title="Go to Start Page"
                type="primaryPurple"
                size="l"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
